import ClickOutside from '../directive/clickOutside';

export default ({ app }) => {
  app.directive('click-outside', ClickOutside);
};
